/**
 * Two-finger pinch math — SPEC.md §3, issue #8. Pure and DOM-free like
 * `viewport.ts`, whose `Point` type it reuses: the calling component
 * (Preview.tsx) owns the pointerId bookkeeping and calls into
 * `viewport.zoomBy` with what this module computes.
 */
import type { Point } from './viewport';

export function distance(a: Point, b: Point): number {
  return Math.hypot(a.x - b.x, a.y - b.y);
}

export function midpoint(a: Point, b: Point): Point {
  return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
}

/**
 * The factor to zoom by, given a two-finger pinch's finger positions before
 * and after a move. Null when the fingers started at the same point — the
 * ratio is undefined, not zero or one, and null lets the caller skip the
 * frame rather than apply a nonsense factor.
 */
export function pinchZoomFactor(oldA: Point, oldB: Point, newA: Point, newB: Point): number | null {
  const oldDistance = distance(oldA, oldB);
  if (oldDistance === 0) return null;
  return distance(newA, newB) / oldDistance;
}
